import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type MusicalWorkLinkViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  urlValue?: { displayId: string; id: string } | null;
  url: string;
  platformValue: { displayId: string; id: string } | null;
  typeValue: { displayId: string; id: string } | null;
};

export const MusicalWorkLinkViewForm: React.FC<MusicalWorkLinkViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      url = "",
      platformValue,
      typeValue,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupMusicalWorkLinkLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={url}
                  label={langStore.MusicalWorkLinkUrlLabel}
                />
                <ShowReference
                  label={langStore.MusicalWorkLinkPlatformLabel}
                  selectedValue={langStore.displayIdByLang(
                    platformValue?.displayId
                  )}
                />
                <ShowReference
                  label={langStore.MusicalWorkLinkTypeLabel}
                  selectedValue={langStore.displayIdByLang(
                    typeValue?.displayId
                  )}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
